module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_tierp-889919e9b8bc44742aacbc9693c5800f.png";